import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/arc2.svg")